import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      En nordo agrikulturado estas peniga. 
      Homoj suferas laborante kaj damnas sian laboregon; sed ĉu povas kreski bona rikolto, se la kultivantoj malbenas sian laboregon kaj do ĝiajn fruktojn?
    </p>
    
    <p class="mb-3">
      Sed en moderaj landoj la grundoj estas fruktodonaj, kaj la kampara laboro estas ne Dia damno, sed kunfluado kun la fortoj de naturo, reciproka amo. 
    </p>
    
    <p class="mb-3">
      De la amo naskiĝas infanoj; kaj de reciproka amo de homoj kaj kultivata tero naskiĝas floroj. 
      Tie floroj abunde kreskas apud vilaĝaj domoj, per florkronoj ornamas siajn kapojn kamparaj junulinoj; sur la blankaj freŝkalkumitaj muroj virinoj pentras florojn. 
      Floroj abundas ĉie. La tero donacas ilin al homoj kiel simbolo de amo.
    </p>
    `
  )
}

const itemName = {
  esp: 'La amo de la Tero'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item; 